import React from 'react';
import { Link } from 'react-router-dom';
import RegisterForm from './RegisterForm';
import singlePageStyles from '../common/SinglePage.module.scss';
import Layout from '../global/Layout';
import { useTranslation } from 'react-i18next';
const RegisterPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Layout>
      <div className={singlePageStyles.wrapper}>
        <h1>{t('pages.register.title')}</h1>

        <p>{t('pages.register.text')}</p>

        <RegisterForm />

        <div className={singlePageStyles.otherActions}>
          <Link to='/login'>{t('pages.register.otherActions.login')}</Link>
        </div>
      </div>
    </Layout>
  );
};

export default RegisterPage;
